import React from 'react';
import {Drawer, DrawerBodyProps} from '@mantine/core';

export const EtroDrawerBody: React.FC<DrawerBodyProps> = props => {
  return <Drawer.Body {...props} />;
};
